import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrontendAudit } from '@core/models/audit.model';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AuditService {
  private readonly endpoint = 'v1/generals/audit/frontend-errors';
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  logError(payload: FrontendAudit): void {
    this.http.post(`${this.API_URL}/${this.endpoint}`, payload).subscribe({
      error: () => {},
    });
  }
}
